/** @format */

import COLORS from '../../colors';

/** @format */

const OplPaginatorStyle = {
    paginatorTextField: { height: 30, border: 0 },
    paginatorInputStyle: {
        height: 30,
        boxSizing: 'border-box',
        borderBottom: '2px solid',
        borderRadius: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: 5,
        paddingLeft: 5,
        lineHeight: '150%',
        borderColor: COLORS.MAIN.PRIMARY,
    },
    paginatorLabelStyle: {
        width: 60,
        height: 30,
        borderBottom: 0,
        borderRadius: 0,
        marginRight: 10,
    },
    lastPage: {
        minWidth: 40,
        width: 40,
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'transparent',
            color: COLORS.MAIN.PRIMARY,
        },
        '&:focus': {
            backgroundColor: 'transparent',
        },
    },
    pagination: {
        display: 'inline-block',
        paddingLeft: '0',
        margin: '20px 0',
        borderRadius: '4px',
    },
    paginationItem: {
        display: 'inline',
    },
};

export default OplPaginatorStyle;
